// extracted by mini-css-extract-plugin
export var wordContainer = "_re-0";